import { useEffect, useState } from "react";
import { ExternalLink, Globe, Mail, Server } from "lucide-react";
import { api } from "@/lib/api";
import { SslBadge } from "@/components/twentyi/ui";

const Section = ({ icon: Icon, title, testId, children }) => (
  <section data-testid={testId} className="card-tech rounded-2xl p-6">
    <h2 className="flex items-center gap-2 font-display text-lg font-bold text-white"><Icon className="h-4 w-4 text-cyan-300" />{title}</h2>
    <ul className="mt-3 space-y-2 text-sm text-slate-200">{children}</ul>
  </section>
);

export default function PortalHosting() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/portal/hosting").then((r) => setD(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <p data-testid="portal-hosting-error" className="text-red-300">Couldn't load hosting details.</p>;
  if (!d) return <p className="text-slate-500">Loading…</p>;
  const empty = !d.domains.length && !d.packages.length && !d.mailboxes.length;
  return (
    <div data-testid="portal-hosting-page" className="space-y-5">
      <h1 className="font-display text-3xl font-bold text-white">Hosting</h1>
      {empty && <p data-testid="portal-hosting-empty" className="text-slate-400">No hosting is assigned to your account yet.</p>}
      {d.packages.length > 0 && <Section icon={Server} title="Websites" testId="portal-hosting-packages">
        {d.packages.map((p) => <li key={p.name} className="flex flex-wrap items-center gap-3"><span className="flex-1">{p.name} · {p.status}</span><SslBadge status={p.ssl} testId={`portal-ssl-${p.name}`} />
          <a href={p.site_url} target="_blank" rel="noopener noreferrer" data-testid={`portal-site-${p.name}`} className="inline-flex items-center gap-1 text-cyan-200 underline">Visit <ExternalLink className="h-3.5 w-3.5" /></a></li>)}
      </Section>}
      {d.domains.length > 0 && <Section icon={Globe} title="Domains" testId="portal-hosting-domains">
        {d.domains.map((x) => <li key={x.domain} data-testid={`portal-domain-${x.domain}`}>{x.domain} · expires {x.expiry || "—"}</li>)}
      </Section>}
      {d.mailboxes.length > 0 && <Section icon={Mail} title="Email" testId="portal-hosting-mail">
        {d.mailboxes.map((m) => <li key={m.address} className="flex gap-3"><span className="flex-1">{m.address}</span><a href={m.webmail} target="_blank" rel="noopener noreferrer" data-testid={`portal-webmail-${m.address}`} className="text-cyan-200 underline">Webmail</a></li>)}
      </Section>}
    </div>
  );
}
